import { NgComponentOutlet } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import type { PushNotificationsTwaComponent } from '@bcf-v2-ui-legacy-others-components-sportsbook-lvbetpl/mobile-web/push-notifications/push-notifications-twa.component';
import { AppLoadedService } from '@bcf-v2-ui-shared/services/app-loaded.service';

@Component({
  standalone: true,
  selector: 'bcf-root',
  imports: [RouterOutlet, NgComponentOutlet],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  public pushNotificationsTwaComponent: typeof PushNotificationsTwaComponent | undefined;

  constructor(
    private _injector: Injector,
    private _appLoadedService: AppLoadedService
  ) {}

  public ngOnInit(): void {
    this._initApp();
    this._initPushNotifications();
    this._initLogRocket();
    this._appLoadedService.init();
    this._initAppsFlyerAnalytics();
    this._initAppDestroy();
  }

  private async _initApp(): Promise<void> {
    this._injector
      .get(
        (
          await import(
            /* webpackChunkName: "app-initializator" */ '@apps/projects/casino/lvbetcom/mobile-web/src/app/app-initializator'
          )
        ).LazyInitializatorCsLvbetcomMobileWeb
      )
      .init();
  }

  private async _initAppsFlyerAnalytics(): Promise<void> {
    this._injector
      .get(
        (
          await import(
            /* webpackChunkName: "app-initializator" */ '@bcf-v2-ui-utilities/analytics/twa-apps-flyer-analytics.service'
          )
        ).TwaAppsFlyerAnalyticsService
      )
      .init();
  }

  private async _initPushNotifications(): Promise<void> {
    this.pushNotificationsTwaComponent = await import(
      /* webpackChunkName: "push-notifications-initializer" */ '@bcf-v2-ui-legacy-others-components-sportsbook-lvbetpl/mobile-web/push-notifications/push-notifications-twa.component'
      // eslint-disable-next-line @typescript-eslint/typedef
    ).then((mod) => mod.PushNotificationsTwaComponent);
  }

  private async _initLogRocket(): Promise<void> {
    this._injector
      .get(
        (
          await import(
            /* webpackChunkName: "log-rocket" */ '@bcf-v2-ui-utilities/analytics/log-rocket-initializer.service'
          )
        ).LogRocketInitializerService
      )
      .init();
  }

  private async _initAppDestroy(): Promise<void> {
    this._injector
      .get(
        (await import(/* webpackChunkName: "app-destroy" */ '@bcf-v2-ui-shared/services/app-destroy.service'))
          .AppDestroyService
      )
      .init();
  }
}
